var local = '';
var localStorageApiUrl = window.localStorage.getItem('apiUrl');
var apiUrl = localStorageApiUrl;
apiUrl = changeBeService(apiUrl);
if(apiUrl == null){
	apiUrl = 'http://localhost:9090/api';
}